import React from "react";
import SectionShell from "./SectionShell";

export default function MissionWorldviewSection() {
  return (
    <SectionShell
      id="vilagkep"
      testId="mission-worldview-section"
      eyebrow="Misszió"
      titleStart="A"
      titleAccent="világkép"
    >
      <p>
        A világ nem akkor változik meg, amikor mindenki ugyanúgy kezd gondolkodni,
        hanem amikor egyre többen visszatalálnak önmagukhoz. Ahhoz a részükhöz, amelyet
        nem a félelem formált, nem a megfelelés vagy a bizonyítás. Ahhoz a belső
        minőséghez, amely mindig is ott volt bennük.
      </p>

      {/* Symbolic image — inner order, chakras, sunset lake */}
      <figure className="my-10 md:my-12">
        <div className="portrait-frame relative max-w-xl mx-auto">
          <img
            data-testid="mission-worldview-image"
            src="/images/missio-belso-rend.jpg"
            alt="Belső rend helyreállítása — meditáció naplementében, csakrák, vízparti béke"
            className="w-full h-auto block"
            style={{ filter: "saturate(0.98) contrast(1.02)" }}
            loading="lazy"
          />
        </div>
      </figure>

      <p>
        Hiszem, hogy az ember természetes állapota a{" "}
        <span className="text-gold">kapcsolódás</span>. Kapcsolódás önmagához,
        egymáshoz és ahhoz a belső rendhez, amelyből a bizalom, az együttműködés és a
        szeretet természetes módon megszülethet.
      </p>
      <p>
        Életünk során azonban sokszor eltávolodunk ettől. A sérülések, veszteségek, családi
        minták, kimondatlan történetek és félelmek lassan olyan rétegeket építenek körénk,
        amelyek már nem azt tükrözik, akik valójában vagyunk. Mégis hiszem, hogy
        mindannyiunkban ott rejlik a lehetőség egy új minőség megteremtésére. Nem a múlt
        újraélésére, hanem arra, hogy tudatossággal, önismerettel és tiszta szándékkal másképp
        kezdjünk jelen lenni önmagunkkal, egymással és a világban. Vannak felismerések,
        amelyeket pusztán logikával nem érthetünk meg. Amikor megengedjük magunknak, hogy ne
        csak elemezni, hanem valóban megélni is kezdjük önmagunkat és kapcsolatainkat, egészen
        új távlatok nyílhatnak meg előttünk. Számomra ezt jelenti a szív tér megnyitása, ahol
        már nem az elme az úr. Ahogy a belső rend elkezd helyreállni, az előbb-utóbb kívül is
        megnyilvánul.
      </p>

      {/* Verse-like cascade — separate lines, finom rhythm, premium box */}
      <aside
        data-testid="mission-cascade"
        className="my-8 md:my-10 mx-auto max-w-xl bg-warm border border-hairline px-7 md:px-10 py-7 md:py-8"
      >
        <p className="font-serif-display italic text-graphite text-[22px] sm:text-[24px] md:text-[27px] leading-[1.45] text-center">
          Amikor egy ember megváltozik,
          <br />
          megváltoznak a kapcsolatai.
          <br />
          <br />
          Amikor a kapcsolatok változnak,
          <br />
          átalakul a család.
          <br />
          <br />
          Amikor egyre több családban helyreáll a belső rend,
          <br />
          lassan a közösségek is átalakulnak.
        </p>
      </aside>

      {/* Symbolic image — a változás belül kezdődik, család és közösség köre */}
      <figure className="my-10 md:my-12">
        <div className="portrait-frame relative max-w-xl mx-auto">
          <img
            data-testid="mission-worldview-connecting-image"
            src="/images/missio-valtozas-belul.jpg"
            alt="A változás belül kezdődik. A hatása mindenkit érint. Együtt teremtjük az új világot. — család, közösség, kapcsolódás"
            className="w-full h-auto block"
            style={{ filter: "saturate(0.98) contrast(1.02)" }}
            loading="lazy"
          />
        </div>
      </figure>

      <p>
        Hiszem, hogy a társadalom valódi változása nem kívülről kezdődik, hanem azzal,
        ahogyan az emberek önmagukhoz és egymáshoz kapcsolódnak. Ezért számomra minden
        változás az embernél, a családnál és a kapcsolatainknál kezdődik.
      </p>
    </SectionShell>
  );
}
